import { oc } from '@orpc/contract';
import { createUserInputSchema, tenantUserSchema } from '../schemas/users.schemas.js';
export const createUserContract = oc
    .route({
    method: 'POST',
    path: '/users',
    tags: ['Users'],
    summary: "Create a user and give it a membership in the caller's tenant",
})
    .input(createUserInputSchema)
    .output(tenantUserSchema);
//# sourceMappingURL=create-user.contract.js.map